import {defineRecipe} from '@chakra-ui/react3'

/**
 * Recipe for the shared header icon-button chrome.
 *
 * A LOCAL, single-purpose recipe — deliberately NOT a `buttonRecipe` variant
 * (`app/leap/theme/recipes/button.js`) — so the round 36×36 shape, hover, and
 * focus-ring styling shared by the header's cart/account CTAs and the mobile
 * menu toggle stay isolated from the global button theme (STOK-17031 Step
 * 10). `header-icon-button.jsx` applies this on top of `Button` rendered
 * `unstyled`, so none of `buttonRecipe`'s base/variant styles leak in.
 */
export const headerIconButtonRecipe = defineRecipe({
    className: 'header-icon-button',
    base: {
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: '0',
        borderRadius: 'round',
        cursor: 'pointer',
        padding: 'spacing-8',
        bg: 'primary.base.white',
        transitionProperty: 'background',
        transitionDuration: 'moderate',
        _hover: {
            bg: 'background.section.subtle'
        },
        _focusVisible: {
            outlineStyle: 'solid',
            outlineColor: 'border.strong',
            // Figma draws the focus state as a separate 42px ring graphic around
            // the 36px button rather than a CSS outline. We approximate it with an
            // outline instead of an extra DOM node: 36px + 2 × (2px offset + 1px
            // width) = 42px outer edge, matching the Figma ring. No offset/width
            // token exists yet, so these stay literals until design provides one.
            outlineOffset: '2px',
            outlineWidth: '1px'
        },
        _icon: {
            color: 'icons.primary',
            width: 'spacing-20',
            height: 'spacing-20'
        }
    }
})
